import { useEffect } from "react";

/**
 * Lightweight head manager. Sets title/description/og + injects JSON-LD schema.
 * Cleans up on unmount so each route owns its tags.
 */
function setMeta(name, content, isProperty = false) {
  if (!content) return null;
  const attr = isProperty ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  let created = false;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
    created = true;
  }
  el.setAttribute("content", content);
  return { el, created };
}

export default function SEOHead({ title, description, image, schema, url }) {
  useEffect(() => {
    const created = [];
    const prevTitle = document.title;
    if (title) document.title = title;

    if (description) created.push(setMeta("description", description));
    if (description) created.push(setMeta("og:description", description, true));
    if (title) created.push(setMeta("og:title", title, true));
    if (image) created.push(setMeta("og:image", image, true));
    if (url) created.push(setMeta("og:url", url, true));
    created.push(setMeta("og:type", "website", true));
    created.push(setMeta("twitter:card", "summary_large_image"));
    if (title) created.push(setMeta("twitter:title", title));
    if (description) created.push(setMeta("twitter:description", description));
    if (image) created.push(setMeta("twitter:image", image));

    let schemaScript = null;
    if (schema) {
      schemaScript = document.createElement("script");
      schemaScript.type = "application/ld+json";
      schemaScript.setAttribute("data-optivize-schema", "1");
      schemaScript.text = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }

    return () => {
      document.title = prevTitle;
      created.forEach((c) => {
        if (c && c.created && c.el && c.el.parentNode) c.el.parentNode.removeChild(c.el);
      });
      if (schemaScript && schemaScript.parentNode) schemaScript.parentNode.removeChild(schemaScript);
    };
  }, [title, description, image, JSON.stringify(schema), url]);

  return null;
}
